import React from "react";
import SearchInput from "../../../components/ui/SearchInput";
import BatchPaginationBar from "./BatchPaginationBar";

const BatchListControls = ({
  page,
  totalRecords,
  rowsPerPage,
  onPageChange,
  searchTerm,
  onSearchChange,
  searchPlaceholder,
}) => (
  <div className="flex flex-col gap-3 pb-3 sm:flex-row sm:items-center sm:justify-between">
    <BatchPaginationBar
      page={page}
      totalRecords={totalRecords}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
    />
    <SearchInput
      value={searchTerm}
      onChange={onSearchChange}
      placeholder={searchPlaceholder}
      className="sm:max-w-xs"
    />
  </div>
);

export default BatchListControls;
